import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';
import { AuthTemplate } from '../templates/auth';
import { DefaultTemplate } from '../templates/default';
import InAppTemplate from '../templates/default/in-app-template-with-sidebar';
import { SimpleTemplate } from '../templates/default/simple-template';
import AccountManagement from '../views/account-management';
// import Accounts from '../views/accounts';
// import Auth from '../views/auth/auth';
import ConfigureProfile from '../views/auth/page/configure-profile';
import Login from '../views/auth/page/login';
import NotFound from '../views/notFound';
import { ProspectingView } from '../views/prospecting';
import { paths } from './paths';
import { WaitForInitialAuthentication } from './waitForInitialAuthentication';
import { ProspectCollectionsView } from '../views/prospect-collections';
import { SearchViewContainer } from '../views/prospecting/search-view/search-view-container';
import { ImportProspectsView } from '../views/prospecting/import-prospects-view/import-prospects-view';
import UserContactsView from '../views/prospect-collection';

export const Routes = () => {
    return (
        <WaitForInitialAuthentication>
            <RouterRoutes>
                <Route path={paths.HOME} element={<Navigate to={paths.PROSPECT_COLLECTIONS} />} />
                <Route element={<DefaultTemplate />}>
                    {/* <Route path={paths.AUTH} element={<Auth />} />
                        <Route path={paths.ACCOUNTS} element={<Accounts />} /> */}
                    <Route path={paths.NOT_FOUND} element={<NotFound />} />
                </Route>
                <Route element={<InAppTemplate />}></Route>
                <Route element={<InAppTemplate />}>
                    <Route path={paths.PROSPECT_COLLECTIONS} element={<ProspectCollectionsView />} />
                    <Route path={paths.PROSPECT_COLLECTIONS + '/:id'} element={<UserContactsView />} />

                    <Route path={`${paths.PROSPECTING}/*`} element={<ProspectingView />}>
                        <Route path="" element={<Navigate to={`${paths.PROSPECTING}/search`} replace />} />
                        <Route path="search" element={<SearchViewContainer />} />
                        <Route path="import-prospects" element={<ImportProspectsView />} />
                    </Route>
                </Route>
                <Route element={<SimpleTemplate />}>
                    <Route path={paths.ACCOUNT_MANAGEMENT + '/:view'} element={<AccountManagement />} />
                    <Route path={paths.ACCOUNT_MANAGEMENT} element={<AccountManagement />} />
                </Route>
                <Route element={<AuthTemplate />}>
                    <Route path={paths.LOGIN} element={<Login />} />
                    <Route path={paths.CONFIGURE_PROFILE} element={<ConfigureProfile />} />
                </Route>
                <Route path="/auth.html" element={<div>Redirecting...</div>} />
                <Route element={<DefaultTemplate />}>
                    <Route path="*" element={<NotFound />} />
                </Route>
            </RouterRoutes>
        </WaitForInitialAuthentication>
    );
};
